import * as React from 'react';

import { DomainPermission } from '../../types/DomainPermission';
import { AddNewDomainDialogInformation } from './AddNewDomainDialogInformation';
import { AddNewDomainTextField, AddNewDomainTextFieldProps } from './AddNewDomainTextField';
import { DomainPermissionsSelector, DomainPermissionsSelectorProps } from './DomainPermissionsSelector';
import { PoolAssignmentDropdown, PoolAssignmentDropdownProps } from './PoolAssignmentDropdown';

export type AddNewDomainDialogBodyProps = DomainPermissionsSelectorProps & PoolAssignmentDropdownProps & AddNewDomainTextFieldProps;

export function AddNewDomainDialogBody(props: AddNewDomainDialogBodyProps) {
    return (
        <>
            <AddNewDomainDialogInformation />
            <AddNewDomainTextField onDomainNameChange={props.onDomainNameChange} domainName={props.domainName} domainValidationStatus={props.domainValidationStatus} />
            <DomainPermissionsSelector onDomainPermissionChange={props.onDomainPermissionChange} domainPermission={props.domainPermission} />
            {renderDomainPoolAssignmentIfAllowed(props.domainPermission, { onPoolAssignmentChange: props.onPoolAssignmentChange, assignedPoolID: props.assignedPoolID, poolOptions: props.poolOptions })}
        </>
    );
}

function renderDomainPoolAssignmentIfAllowed(domainPermission: DomainPermission, domainPoolAssignmentProps: PoolAssignmentDropdownProps) {
    if (domainPermission === DomainPermission.BLOCK) {
        return <></>;
    }
    return <PoolAssignmentDropdown {...domainPoolAssignmentProps} />;
}
